import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

function formatErr(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
}

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to Djino Stream!");
      navigate("/subscriptions");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 relative overflow-hidden" data-testid="signup-page">
      <img src="https://images.unsplash.com/photo-1635805737707-575885ab0820?w=1920&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/85 to-[#050505]/60" />

      <div className="relative w-full max-w-md bg-[#0a0a0a]/80 backdrop-blur-xl border border-white/10 rounded-2xl p-8 sm:p-10 shadow-2xl">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-lg bg-[#E50914] flex items-center justify-center font-black text-white shadow-[0_0_20px_rgba(229,9,20,0.5)]" style={{ fontFamily: "Outfit" }}>D</div>
          <span className="text-2xl font-black" style={{ fontFamily: "Outfit" }}>Djino<span className="text-[#E50914]">Stream</span></span>
        </Link>
        <h1 className="text-3xl font-black mb-1" style={{ fontFamily: "Outfit" }}>Create your account</h1>
        <p className="text-sm text-[#999] mb-6">Start streaming in under 60 seconds.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-medium uppercase tracking-wider text-[#888] mb-1.5 block">Name</label>
            <input required value={name} onChange={(e) => setName(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="Your name" data-testid="signup-name-input" />
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wider text-[#888] mb-1.5 block">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="you@email.com" data-testid="signup-email-input" />
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wider text-[#888] mb-1.5 block">Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="At least 6 characters" data-testid="signup-password-input" />
          </div>
          <button type="submit" disabled={loading} className="w-full btn-primary justify-center !py-3" data-testid="signup-submit-btn">
            {loading ? "Creating account..." : "Create account"}
          </button>
        </form>

        <p className="mt-5 text-center text-sm text-[#999]">
          Already have an account? <Link to="/login" className="text-[#E50914] hover:text-[#F6121D] font-semibold" data-testid="login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
